export default __webpack_public_path__ + "static/media/7.0ccbd5ec.svg";